<template>
  <button class="btn clear-filter-button" :aria-label="label" v-tooltip="{ content: label }"  @click="handleClick" :disabled="!hasFilters" data-tour-item="clearFilter">
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
         stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
         class="icon feather feather-refresh-ccw">
      <path d="M1 4v6h6M23 20v-6h-6"/>
      <path d="M20.49 9A9 9 0 005.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 013.51 15"/>
    </svg>
  </button>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {appDict} from "@/features/FeatureHelper";

export default {
  name: "ClearFilterButton",
  props: {
    onClick: {
      type: Function,
      default: null
    },
    
  },
	methods: {
			...mapActions('filters', ['clearFilters']),
		...mapActions('drawer', ['openSingleInDrawer']),
		...mapActions('inlineDrawers', ['openFlyer']),
     handleClick() {
      if (this.onClick) {
        this.onClick();
      } else {
        this.clearFilters();
        	if (this.isFilterOpen) {
				this.openSingleInDrawer({id: 'flyerSelector', component: appDict.inlineFlyerSelector, drawer: 'left', attrs: {}});
				this.openFlyer();
			}
      }
  }
	},
	computed:{
    ...mapGetters(['content']),
		...mapGetters('filters', ['hasFilters']),
    ...mapGetters('inlineDrawers', ['isFilterOpen']),
    label() {
      return this.onClick ? this.content.clearBrands : this.content.clearSearch 
    }
	}
}
</script>

<style scoped>

</style>
<style lang="scss">
[mode='mobile'],
[mode='tablet']  {
  .clear-filter-button{
    margin-left: auto;
  }

}</style>
